import { formatDateMoment, separateNumber } from 'utils/utils'

export const TABLE_EXPORT_POINT_MEMBER = {
    name: 'History Export',
    column: [
        {
            name: 'Rentang Tanggal Data',
            key: 'date_range',
        },
        {
            name: 'Nama Admin',
            key: 'name',
        },
        {
            name: 'Jumlah Data',
            key: 'total_exported_user',
            render: ({ value }) => separateNumber(value),
        },
        {
            name: 'Created At',
            key: 'created_at',
            render: ({ value }) => formatDateMoment(value, 'DD/MM/YYYY HH:mm'),
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    search: '',
    page: 1,
    limit: 20,
}
